var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('header',{staticClass:"header"},[_vm._t("header")],2),_c('md-content',{staticClass:"content md-scrollbar h-100"},[_vm._t("content")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }